module.exports = __webpack_public_path__ + "static/media/bitcoin-wallet-small.8141973a.jpg";